import React, { useContext } from "react"

import { StateContext } from "../components/el/provider"
import { Link, useStaticQuery, graphql } from "gatsby"
import { motion } from "framer-motion"
import LinkedinIcon from "./svg/brands/LinkedinIcon"
import { ShoppingBagIcon } from "@heroicons/react/24/outline"
import { ShoppingCartIcon } from "@heroicons/react/24/outline"
const Footer = () => {
  const { stateCart, stateBag } = useContext(StateContext)
  const [cart] = stateCart
  const [bag] = stateBag
  const d = new Date()
  const year = d.getFullYear()
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          company {
            company
            tag
          }
        }
      }
    }
  `)
  return (
    <footer className="border-t bg-white">
      <div className="mx-auto max-w-screen-xl overflow-hidden px-4 pb-12 pt-8 sm:px-6 lg:px-8 xl:px-16">
        <div className="flex flex-col justify-center md:flex-row md:items-center md:justify-between">
          <div>
            <nav className="-mx-5 -my-2 flex flex-wrap justify-center md:justify-start">
              <FootLink to="/usa">Made in USA</FootLink>
              <FootLink to="/about">About</FootLink>
              <FootLink to="/form/contact">Contact</FootLink>
              <FootLink to="/legal/careers">Careers</FootLink>
              <FootLink to="/legal/legal">Legal</FootLink>
              <FootLink to="/distributors">Distributors</FootLink>
              <FootLink to="/general/iso">
                ISO 9001 Certified by NSF-ISR
              </FootLink>
            </nav>

            <div className="mt-7 flex flex-col items-center justify-center md:flex-row md:justify-start md:space-x-4">
              <p className="text-left text-xs leading-normal text-slate-500">
                &copy; {year} {data.site.siteMetadata.company.company}{" "}
                <span className="hidden md:inline">|</span>
                <br className="md:hidden" />{" "}
                {data.site.siteMetadata.company.tag}
              </p>
              <a
                href="https://www.linkedin.com/company/thomson-instrument/"
                className="mt-4 text-blue-500 hover:text-blue-700 md:mt-0 flex items-center"
              >
                <span className="sr-only">LinkedIn</span>
                <LinkedinIcon className="inline-block h-7 w-7 md:h-4 md:w-4"></LinkedinIcon>
                <span className="ml-1.5 inline-block text-xs text-slate-500 hover:text-blue-600 italic">
                  Follow us!
                </span>
              </a>
            </div>
          </div>
          <div className="order-first mb-12 md:order-last md:mb-0">
            {bag !== undefined && bag.length > 0 ? (
              <CartBadge cart={cart} bag={bag} />
            ) : (
              ``
            )}
          </div>
        </div>
      </div>
    </footer>
  )
}

const CartBadge = props => {
  return (
    <motion.div
      className="rounded-md border border-teal-200 bg-white shadow-md"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5 }}
    >
      <div className="overflow-hidden rounded-md px-4 py-3 shadow-sm">
        <div className="flex flex-col items-center justify-center md:flex-row md:justify-start md:space-x-6">
          <div className="text-center md:text-left">
            <h4 className="mb-0.5 text-base font-semibold text-slate-700 md:text-xs">
              Ready to proccess your {props.cart ? `Order` : `Quote`}?
            </h4>
            <p className="text-sm leading-tight text-slate-500 md:text-xs">
              You have {props.bag.length} item{props.bag.length > 1 ? `s` : ``}{" "}
              in your {props.cart ? `cart` : `bag`}
            </p>
          </div>

          <div>
            <Link
              className="mt-2 inline-flex items-center space-x-2 rounded-md border border-slate-200 bg-blue-50 px-2.5 py-1.5 text-slate-500 hover:border-blue-300 hover:bg-blue-100 hover:text-slate-600 md:mt-0 md:rounded-sm md:px-1.5 md:py-0.5"
              to={props.cart ? `/form/order` : `/form/quote`}
            >
              <span className="text-sm font-light md:text-xs">visit</span>
              {props.cart ? (
                <ShoppingCartIcon className="inline-block h-4 w-4 stroke-current text-blue-500 md:h-3 md:w-3" />
              ) : (
                <ShoppingBagIcon className="inline-block h-4 w-4 stroke-current text-blue-600 md:h-3 md:w-3" />
              )}
            </Link>
          </div>
        </div>
      </div>
    </motion.div>
  )
}

const FootLink = props => {
  return (
    <div className="px-3 pb-1 md:px-4 md:py-2 lg:px-5">
      <Link
        to={props.to}
        className="text-sm leading-6 text-slate-500 hover:text-blue-600"
      >
        {props.children}
      </Link>
    </div>
  )
}

export default Footer
